const billingTabHash = '#!/billing';

export { billingTabHash as default };
